import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import {filter} from 'rxjs/operators';


@Component({
  selector: 'app-root', 
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: []
})
export class AppComponent implements OnDestroy {
    title = 'Rate Integrity';
    subscriptions:Subscription[]=[];

  constructor(private router:Router) {
    this.subscriptions.push(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(
        ((e:NavigationEnd) => {
          let nextUrl = e.url;
          this.notInLogonPage = !nextUrl.startsWith('/login');
          this.isPageNotFound = e.urlAfterRedirects.startsWith('/404');
          console.log("notInLogonPage " + this.notInLogonPage);

        }),
        (err)=>console.log(err)
  ));
   
  }
  notInLogonPage:boolean = true;
  isPageNotFound:boolean = false;
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}




